import { setLoader } from '../../reducers/loader';
import { call, put, takeLatest, takeEvery, select } from 'redux-saga/effects';
import { setError } from '../../reducers/error';
import {
	cancel_withdraw_fund_request,
	create_withdraw_fund_request,
	fetch_withdraw_summery_data,
	update_withdraw_fund_request,
} from '../../../apis/equity/funds/withdraw';
import { concat, get, isEmpty, merge, noop } from 'lodash-es';
import {
	cancelWithdrawRequest,
	createWithdrawFundsRequest,
	fetchWithdrawFundsSummery,
	modifyWithdrawRequest,
	setWithdrawFundsSummery,
} from '../../reducers/equity/funds/withdrawFunds';
import {
	fetchLoadMoreTransactionHistory,
	fetchPayinTransactionDetail,
	fetchTransactionHistory,
	fetchWithdrawTransactionDetail,
	getTransactionListData,
	setPayinTransactionDetail,
	setTransactionHistory,
	setWithdrawTransactionDetail,
} from '../../reducers/equity/funds/transactionHistory';
import {
	get_load_more_transaction_list,
	get_payin_transaction_detail,
	get_transaction_list,
	get_withdraw_transaction_detail,
} from '../../../apis/equity/funds/transaction';
import commonBaseService from '../../../services/commonBaseService';

export default function* fetchWithdrawFundsData() {
	yield takeLatest(
		fetchWithdrawFundsSummery.toString(),
		handleFetchWithdrawFundsSummery,
	);
	yield takeLatest(
		createWithdrawFundsRequest.toString(),
		handleWithdrawFunds,
	);
	yield takeLatest(
		cancelWithdrawRequest.toString(),
		handleCancelWithdrawFunds,
	);
	yield takeLatest(
		modifyWithdrawRequest.toString(),
		handleModifyWithdrawFunds,
	);
	// ======== TRANSACTION =============
	yield takeEvery(
		fetchTransactionHistory.toString(),
		handleFetchTransactionHistoryList,
	);
	yield takeLatest(
		fetchWithdrawTransactionDetail.toString(),
		handleFetchWithdrawTransactionDetail,
	);
	yield takeLatest(
		fetchLoadMoreTransactionHistory.toString(),
		handleFetchLoadMoreTransactionList,
	);
	yield takeLatest(
		fetchPayinTransactionDetail.toString(),
		handlePayinTransactionDetail,
	);
}

function* handleFetchWithdrawFundsSummery({ payload }) {
	const {
		Api,
		screen,
		token = '',
		sagaCallback = noop,
		errorCallback = noop,
	} = payload;
	try {
		yield put(setLoader({ screen, isPageLoading: true }));
		yield put(setError({ screen, isFetchFailed: false, message: '' }));
		const response = yield call(fetch_withdraw_summery_data, Api, token) ||
			{};
		yield put(setWithdrawFundsSummery(response));

		yield call(sagaCallback, response);
	} catch (error) {
		console.log('[Error in handleFetchWithdrawFundsSummery]', error);
		yield put(
			setError({ screen, isFetchFailed: true, message: error?.message }),
		);
		yield call(errorCallback, error);
	} finally {
		yield put(setLoader({ screen, isPageLoading: false }));
	}
}

function* handleWithdrawFunds({ payload }) {
	const {
		Api,
		screen,
		data,
		successCallback = noop,
		errorCallback = noop,
	} = payload;
	try {
		yield put(setLoader({ screen, isButtonLoading: true }));
		yield put(setError({ screen, isFetchFailed: false, message: '' }));

		const response = yield call(create_withdraw_fund_request, Api, data) ||
			{};

		yield call(successCallback, response);
	} catch (error) {
		console.log('[Error in handleWithdrawFunds]', error);
		yield put(
			setError({ screen, isFetchFailed: true, message: error?.message }),
		);
		yield call(errorCallback, error);
	} finally {
		yield put(setLoader({ screen, isButtonLoading: false }));
	}
}

function* handleCancelWithdrawFunds({ payload }) {
	const {
		Api,
		screen,
		data,
		sagaCallback = noop,
		errorCallback = noop,
	} = payload;
	try {
		yield put(setLoader({ screen, isButtonLoading: true }));
		yield put(setError({ screen, isFetchFailed: false, message: '' }));
		const response = yield call(cancel_withdraw_fund_request, Api, data) ||
			{};
		yield call(sagaCallback, response);
	} catch (error) {
		console.log('[Error in handleCancelWithdrawFunds]', error);
		yield put(
			setError({ screen, isFetchFailed: true, message: error?.message }),
		);
		yield call(errorCallback, error);
	} finally {
		yield put(setLoader({ screen, isButtonLoading: false }));
	}
}

function* handleModifyWithdrawFunds({ payload }) {
	const {
		Api,
		screen,
		data,
		successCallback = noop,
		errorCallback = noop,
	} = payload;
	try {
		yield put(setLoader({ screen, isButtonLoading: true }));
		yield put(setError({ screen, isFetchFailed: false, message: '' }));
		const response = yield call(update_withdraw_fund_request, Api, data) ||
			{};

		yield call(successCallback, response);
	} catch (error) {
		console.log('[Error in handleModifyWithdrawFunds]', error);
		yield put(
			setError({ screen, isFetchFailed: true, message: error?.message }),
		);
		yield call(errorCallback, error);
	} finally {
		yield put(setLoader({ screen, isButtonLoading: false }));
	}
}

/// ==================== TRANSACTION ===================================
/// ==================== TRANSACTION ===================================
function* handleFetchTransactionHistoryList({ payload }) {
	const {
		Api,
		screen,
		transactionType = 'all',
		pageNo = 1,
		pageSize = 20,
		sagaCallback = noop,
		errorCallback = noop,
	} = payload;
	try {
		yield put(
			setTransactionHistory({
				transactionType: transactionType,
				isPageLoading: true,
				isFetchFailed: false,
				errorStateMessage: '',
			}),
		);

		const requestParams = {
			transactionType,
			pageNo,
			pageSize,
		};
		const response = yield call(get_transaction_list, Api, requestParams);
		const transactionData = get(response, 'transactions', []);
		yield put(
			setTransactionHistory({
				transactions: transactionData,
				nextPageUrl: response?.next_page_url,
				more: response?.more,
				transactionType: transactionType,
				isEmptyList:
					commonBaseService.isEmptyOrUndefined(transactionData),
				isPageLoading: false,
				isFetchFailed: false,
			}),
		);

		yield call(sagaCallback, response);
	} catch (error) {
		console.log('[Error in handleFetchTransactionHistoryList]', error);
		yield put(
			setTransactionHistory({
				transactionType: transactionType,
				isPageLoading: false,
				isFetchFailed: true,
				errorStateMessage: error.message,
			}),
		);

		yield call(errorCallback, error);
	}
}

function* handleFetchWithdrawTransactionDetail({ payload }) {
	const {
		Api,
		screen,
		id = '',
		sagaCallback = noop,
		errorCallback = noop,
	} = payload;
	try {
		yield put(setLoader({ screen, isPageLoading: true }));
		yield put(setError({ screen, isFetchFailed: false, message: '' }));

		const response = yield call(get_withdraw_transaction_detail, Api, {
			id,
		});
		const data = get(response, 'payout_request', {});
		yield put(setWithdrawTransactionDetail({ data: data }));
		yield call(sagaCallback, data);
	} catch (error) {
		console.log('[Error in handleFetchWithdrawTransactionDetail]', error);
		yield put(
			setError({ screen, isFetchFailed: true, message: error?.message }),
		);
		yield call(errorCallback, error);
	} finally {
		yield put(setLoader({ screen, isPageLoading: false }));
	}
}

function* handleFetchLoadMoreTransactionList({ payload }) {
	const {
		Api,
		nextPageUrl = '',
		screen = '',
		transactionType = '',
		sagaCallback = noop,
		errorCallback = noop,
	} = payload;

	try {
		yield put(
			setTransactionHistory({
				transactionType: transactionType,
			}),
		);
		const data = yield call(get_load_more_transaction_list, Api, {
			url: nextPageUrl,
		}) || {};
		const transactionListData = yield select((state) =>
			getTransactionListData(state, transactionType),
		);
		const previousData = get(transactionListData, `transactions`, []);
		const newTransactionData = get(data, 'transactions', []);
		const next_page_url = get(data, `next_page_url`, '');
		const isMoreData = get(data, `more`, false);
		let mergedData = data?.transactions || [];
		if (!isEmpty(newTransactionData)) {
			mergedData = concat(previousData, newTransactionData);
		}

		yield put(
			setTransactionHistory({
				transactions: mergedData,
				nextPageUrl: next_page_url,
				more: isMoreData,
				transactionType: transactionType,
			}),
		);
		yield call(sagaCallback, mergedData);
	} catch (error) {
		console.log('[Error in handleFetchLoadMoreTransactionList]', error);
		yield put(
			setError({ screen, isFetchFailed: true, message: error?.message }),
		);
		yield call(errorCallback, error);
	}
}

function* handlePayinTransactionDetail({ payload }) {
	const {
		Api,
		screen,
		id = '',
		status = '',
		sagaCallback = noop,
		errorCallback = noop,
	} = payload;
	try {
		yield put(setLoader({ screen, isPageLoading: true }));
		yield put(setError({ screen, isFetchFailed: false, message: '' }));

		const response = yield call(get_payin_transaction_detail, Api, {
			id,
			status,
		});
		const data = get(response, 'payout_request', {});
		yield put(setPayinTransactionDetail({ data: data }));
		yield call(sagaCallback, response);
	} catch (error) {
		console.log('[Error in handlePayinTransactionDetail]', error);
		yield put(
			setError({ screen, isFetchFailed: true, message: error?.message }),
		);
		yield call(errorCallback, error);
	} finally {
		yield put(setLoader({ screen, isPageLoading: false }));
	}
}
